// This form is used in all login help options other than "forgot login Id"

import * as React from "react";
import InputField from "../../generic/inputField";
import { emailRegex, pan, alphaNumExp } from "../../utils/regex";
import EdButton from "../../generic/edButton";
import RadioButton from "../../generic/radioButton";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import "../../../assets/scss/Login/login/forms/forgotLoginIdForm.scss";

import { IListObj } from "../../types/genericTypes";
import LoginErrMsg from "../generic/loginErrMsg";
import loginURLConfig from "../../../config/login/loginURLConfig";
import {
  AForgotPassword,
  AForgotPasswordOTP,
} from "../../../services/login/loginApiService";
import { ForgotPasswordScreenEnum } from "../../types/components/login/loginTypes";
import { setPreLoginData } from "../../../services/login/loginService";

export interface IForgotPasswordFormProps {
  onSuccess: (
    msg: string,
    status: ForgotPasswordScreenEnum,
    loginId: string
  ) => void; // function to be called on the success of called apis
}

// form fields
export interface IForgotPasswordFields {
  pan: string;
  email?: string;
  loginId: string;
  accTyp: string;
}

const ForgotPasswordForm: React.FC<IForgotPasswordFormProps> = (props) => {
  // used to store the entered values in form
  const [values, setValues] = React.useState<IForgotPasswordFields>({
    pan: "",
    loginId: "",
    accTyp: "EQ",
  });

  // used to store the field wise errors
  const [errors, setErrors] = React.useState<{
    [key in keyof IForgotPasswordFields]?: string;
  }>({
    pan: undefined,
    email: undefined,
    loginId: undefined,
  });

  // used to store the error message that comes from api
  const [errorMsg, setErrorMsg] = React.useState("");

  // used to store if the form is submitted or not
  const [submitted, setSubmitted] = React.useState(false);

  // to check the route

  const accTyp: Array<IListObj> = [
    { value: "EQ", display: "Equity" },
    { value: "CO", display: "Commodity" },
  ];

  function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    setSubmitted(true);
    setPreLoginData({ accTyp:values.accTyp});
    if (values.accTyp == "CO") {
      if(loginURLConfig.CommKambala == true)
        AForgotPasswordOTP(AForgotPasswordOTPRes, values);
      else
        AForgotPassword(AForgotPasswordRes, values);       
    } else {
      AForgotPasswordOTP(AForgotPasswordOTPRes, values);
    }
  }

  function AForgotPasswordRes(res: any) {
    if (res.data) {
      props.onSuccess(
        res.data.msg,
        ForgotPasswordScreenEnum.COMMODITY_STATUS_SCREEN,
        values.loginId
      );
    } else if (res.error) {
      // else enable form again
      errorHandler(res.error);
    }
  }
  function AForgotPasswordOTPRes(res: any) {
    if (res.data) {
      if (loginURLConfig.CommKambala == true) 
        props.onSuccess("", ForgotPasswordScreenEnum.RESET_OTP_PASSWORD, values.loginId);
      else
        props.onSuccess("", ForgotPasswordScreenEnum.RESET_PASSWORD, values.loginId);
    } else if (res.error) {
      // else enable form again
      errorHandler(res.error);
    }
  }

  function errorHandler(error: any) {
    if (error.errCd === "ELGH0001") {
      // show account type radio
      setValues({ ...values, accTyp: "EQ" });
    } else {
      setErrorMsg(error.errMsg);
    }
  }

  function onChange(key: keyof IForgotPasswordFields, value: string) {
    if ((key === "loginId" || key === "pan") && !alphaNumExp.test(value)) {
      value = values[key];
    }
    if (key == "accTyp" && value === "EQ") {
      delete values.email;
    } else if (key == "accTyp" && value === "CO") {
      loginURLConfig.CommKambala ? (delete values.email) : (values.email = "");
    }
    // onchange of any field remove both type of errors
    setValues({ ...values, [key]: value });
    setErrors({ ...errors, [key]: "" });
    setErrorMsg("");
    setSubmitted(false);

    // return value to be cahnged inside the input field
    return value;
  }
  function getButtonValue() {
    let commBtnValue; 
    loginURLConfig.CommKambala ? (commBtnValue= "Send OTP") : (commBtnValue= "Send new password to my email");
    switch (values.accTyp) {
      case accTyp[0].value:
        return "Send OTP";
      case accTyp[1].value:
        return commBtnValue;
      default:
        return "Proceed";
    }
  }
  return (
    <form className="login_form">
      <div className="same_acc mg-b30">
        {/* <p className="inp_lbl mg-b15">Account type</p>
        <ul className="same_acc_radio mg-b45">
          <li className="list_Item">
            {accTyp.map((typ) => (
              <RadioButton
                key={typ.value}
                list={typ}
                name={"sameAcc"}
                selected={values.accTyp}
                onChange={() => onChange("accTyp", typ.value as string)}
              />
            ))}
          </li>
        </ul> */}
      </div>
      <label className="inp_lbl mg-b5 ib">Login ID</label>
      <InputField
        onChange={(loginId) => onChange("loginId", loginId)}
        onBlur={(error) => {
          setErrors({
            ...errors,
            loginId: error.required ? "Field is required" : "",
          });
        }}
        maxLength={24}
        className="login_inp mg-b40"
        placeholder="Eg:5678987"
        required
        errorText={errors.loginId}
      />
      {values.accTyp === accTyp[1].value && !loginURLConfig.CommKambala && (
        <>
          <label className="inp_lbl mg-b5 ib">Email ID</label>
          <InputField
            pattern={emailRegex}
            required
            onChange={(email) => onChange("email", email)}
            onBlur={(error) =>
              setErrors({
                ...errors,
                email: error.pattern
                  ? ""
                  : "Please enter a valid email address",
              })
            }
            className="login_inp mg-b40"
            placeholder="Eg: sarveshpali@gmail.com"
            errorText={errors.email}
          />
        </>
      )}

      <label className="inp_lbl mg-b5 ib">PAN No.</label>
      <InputField
        onChange={(pan) => onChange("pan", pan)}
        onBlur={(error) =>
          setErrors({
            ...errors,
            pan: error.pattern ? "" : "Please enter a valid PAN",
          })
        }
        className="login_inp mg-b40"
        placeholder="Eg: JUKL5678987"
        helpTextColor="blue"
        required
        pattern={pan}
        errorText={errors.pan}
        maxLength={10}
      />

      {/* Show error if any */}
      {errorMsg && <LoginErrMsg className="mg-b40">{errorMsg}</LoginErrMsg>}

      <EdButton
        value={getButtonValue()}
        btnTyp="primary"
        className="submit_btn"
        // Disable if there is even one error or if any field is empty or if form is submitted
        disabled={
          Object.values(errors).every((error) => error) ||
          Object.values(values).some((value) => !value) ||
          submitted
        }
        onClick={handleSubmit}
      />
    </form>
  );
};

export default ForgotPasswordForm;